<template>
    <div v-if="lawTpInfo" class="info">
        <div class="info-card">
            <div class="info-img">
                <img
                    v-if="lawTpInfo.org_image"
                    class="info-head"
                    :src="lawTpInfo.org_image"
                    alt=""
                />
                <img
                    v-else
                    class="info-head"
                    src="../../../assets/img/law/headdefault.png"
                    alt=""
                />
            </div>
            <div class="info-msg">
                <div
                    v-if="!isAgentSubAccount"
                    class="info-msg-wrapper"
                >
                    <div class="info-msg-name">
                        你好，{{ lawTpInfo.org_name || lawTpInfo.firm_name }}
                    </div>
                    <img
                        v-if="+lawTpInfo.ability_buy_vip === 1"
                        class="vip-icon"
                        src="../../../assets/img/law/vip-icon.png"
                        alt=""
                    />
                    <span class="info-msg-qualified isPass">资质已认证</span>
                    <span class="role">管理员</span>
                </div>
                <div v-else class="info-msg-wrapper">
                    <div>
                        <div class="sub-info-box">
                            <div class="info-msg-name">
                                你好，{{ lawTpInfo.name }}
                            </div>
                            <span class="role">销售成员</span>
                        </div>
                        <div class="firm-box">
                            <span>公司：{{ lawTpInfo.org_name || lawTpInfo.firm_name }}</span>
                            <img
                                v-if="+lawTpInfo.ability_buy_vip === 1"
                                class="vip-icon"
                                src="../../../assets/img/law/vip-icon.png"
                                alt=""
                            />
                            <span class="info-msg-qualified isPass">资质已认证</span>
                        </div>
                    </div>
                </div>
            </div>
            <div
                v-if="!isAgentSubAccount"
                class="info-button"
            >
                <div>账户余额</div>
                <div class="info-button-num"> ¥ <span class="info-button-num-light">{{ availableBalance }}</span></div>
                <veui-button ui="primary" @click="openLawChargeDialog">去充值</veui-button>
            </div>
        </div>
        <div class="board">
            <div class="board-title">我的首页</div>
            <div class="board-power">
                <veui-popover target="boardPoweItem" position="top-start">
                    <span class="help-text">个人资料会展示在您的律师主页卡中，请务必填写律师本人的真实信息，便于用户在平台找到您</span>
                </veui-popover>
                <!-- 子账号-快捷菜单 -->
                <div v-if="isAgentSubAccount">
                    <div class="board-power-item" @click="goto('memberCodeManage')">
                        <img src="../../../assets/img/law/member.png" alt=""/>
                        会员码管理
                    </div>
                    <div class="board-power-item" @click="goto('customerList')">
                        <img src="https://lvlin-base.cdn.bcebos.com/fe-saas/common/customer-manage-new.png" alt=""/>
                        客户管理
                    </div>
                    <div class="board-power-item" @click="goto('potentialCustomerList')">
                        <img src="https://lvlin-base.cdn.bcebos.com/fe-saas/common/potential-customer-new.png" alt=""/>
                        潜客管理
                    </div>
                </div>
                <!-- 主账号-快捷菜单 -->
                <div v-else>
                    <div class="board-power-item" @click="goto('goodsPurchase')">
                        <img src="https://lvlin-base.cdn.bcebos.com/fe-saas/common/goods-purchase-menu.png" alt=""/>
                        商品购买
                    </div>
                    <div class="board-power-item" @click="goto('memberCodeManage')">
                        <img src="https://lvlin-base.cdn.bcebos.com/fe-saas/common/vip-code-icon.png" alt=""/>
                        会员码管理
                    </div>
                    <div class="board-power-item" @click="goto('clueOrderManage')">
                        <img src="../../../assets/img/law/my-article.png" alt=""/>
                        订单管理
                    </div>
                    <div class="board-power-item" @click="goto('agentMemberManage')">
                        <img src="https://lvlin-base.cdn.bcebos.com/fe-saas/common/member-manage-new.png" alt="" />
                        成员管理
                    </div>
                </div>
            </div>
        </div>
        <law-footer class="lawfooter"></law-footer>
        <law-charge-dialog :show.sync="lawChargeShow"></law-charge-dialog>
    </div>
</template>

<script>
/**
 * @file law-info.vue
 * @author baoleilei
 * @desc 我的首页
 */
import {Popover, Button} from 'veui';
import mixinajax from '@/mixins/ajax';
import LawFooter from '@/components/LawFooter';
import lawLinkUrl from '@/components/law-bjh-tip/lawLinkUrl';
import lawChargeDialog from '@/components/law-bjh-tip/lawChargeDialog';
import bendSDK from '@baidu/bend-plugin-sdk';
import {mapState} from 'vuex';
import get from 'lodash/get';
const url = {
    // 消息列表
    indexPage: 'law:/themis/law/index/indexPage',
    getChargeUrl: '/bp/api/mid/law_recharge',
    chargeList: '/bp/api/mid/law_queryrechargelist'
};
export default {
    name: 'info',
    mixins: [mixinajax],
    components: {
        'veui-popover': Popover,
        'law-footer': LawFooter,
        'veui-button': Button,
        'law-charge-dialog': lawChargeDialog
    },
    data() {
        return {
            vipInfo: null,
            consulting_info: null,
            article_info: {},
            info_status: '',
            lawChargeShow: false,
            availableBalance: '0.00'
        };
    },
    computed: {
        ...mapState({
            lawTpInfo: state => state.lawStore.userInfoNew.law_firm_info || state.lawStore.userInfoNew.law_firm_subaccount || {},
            isAgentSubAccount: state => +state.lawStore.userInfoNew.user_role === 3
        })
    },
    created() {
        // this.getData();
        this.getChargeList();
    },
    methods: {
        getData() {
            this.$http.get(url.indexPage)
                .then(res => {
                    res = this.$normalizeResponseData(res);
                    if (res) {
                        this.vipInfo = res.vip_Info || {};
                        this.info_status = res.persondetail.info_status;
                        this.consulting_info = res.consulting_info || {};
                        this.article_info = res.article_info || {};
                    }
                    else {
                        this.$Message.error({
                            content: res.error_msg,
                            duration: 5
                        });
                    }
                })
                .catch(error => {
                    this.$Message.error({
                        content: error.msg || '数据请求出错',
                        duration: 5
                    });
                });
        },
        goto(routerName) {
            if (routerName === 'bjhContent') {
                // 跳转到百家号文章管理页面
                this.$store.dispatch('lawStore/openWindow', lawLinkUrl.bjhContent);
            }
            else {
                this.$router.push({name: routerName});
            }
        },
        getChargeList() {
            const data = {
                account_id: window?.merchants_id,
                capital_type: 1,
                charge_type: '1',
                is_show_balance: 1,
                page: 1,
                page_size: 1
            };
            this.$http.post(url.chargeList, {
                ...data,
                params: JSON.stringify(data)
            }).then(resp => {
                const respData = this.$normalizeResponseData(resp);
                if (respData) {
                    this.availableBalance = (respData.available_balance / 100).toFixed(2);
                }
            }).catch(err => this.$normalizeResponseError(err));
        },
        openLawChargeDialog() {
            this.lawChargeShow = true;
        }
    }
};
</script>

<style lang="stylus" scoped>
.help-text
        font-size 14px
.info
    .lawfooter
        position absolute
        bottom 18px

    .info-card
        display flex
        background #fff
        padding 24px
        border-radius 4px
        .info-img
            display flex
            align-items center
        .info-head
            width 90px
            border-radius 50%
        .info-button
            display flex
            align-items center
            margin-right 55px
            flex-direction column
            justify-content space-between
            padding 1px 0
            .info-button-num
                height: 20px;
                line-height: 20px;
                font-size: 14px;
                color: #FF321B;
            .info-button-num-light
                font-size: 20px;
                font-family: PingFangSC-Medium;
        .info-msg
            flex 1
            padding 13px 0 0 16px
            font-size: 14px;
            color #282C33
            .info-msg-wrapper
                display flex
                align-items center
                .info-msg-name
                    font-size 20px
                    font-weight 600
                .sub-info-box
                    display flex
                    align-items center

                .firm-box
                    display flex
                    align-items center
                    margin-top 11px
                    font-family PingFangSC-Regular
                    font-size 14px
                    color #282C33
                    font-weight 400
                .vip-icon
                    width 24px
                    margin-left 12px
                .info-msg-qualified
                    height 22px
                    font-family PingFangSC-Regular
                    font-weight 400
                    font-size 14px
                    color #05f
                    background rgba(0, 85, 255, .08)
                    border-radius 2px
                    line-height 22px
                    padding 0 6px
                    margin-left 12px
                .isPass
                    color #05f
                    background rgba(0, 85, 255, .08)
                .role
                    margin-left 12px
                    padding 4px 6px
                    background rgba(0, 85, 255, .08)
                    border-radius 2px
                    font-family PingFangSC-Regular
                    font-size 14px
                    color #05f
                    line-height 14px
                    font-weight 400
    .board
        margin-top 23px
        background #fff
        padding 24px
        border-radius 4px
        .board-title
            font-size: 20px
            color: #282C33
            font-weight 700
        .board-power
            margin-top 24px
            overflow hidden
            .board-power-item
                width 140px
                border-radius: 6px;
                border: 1px solid #E2E6F0;
                display flex
                flex-direction column
                align-items center
                justify-items center
                margin-right 24px
                float left
                padding-bottom 9px
                cursor pointer
                img
                    width 48px
                    display block
                    margin-bottom 9px
                    margin-top 14px
            .gray
                opacity .5
                cursor no-drop
</style>
